<script>
import countTo from 'vue-count-to'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'

import {
  sspsImpressionChart,
  sspsRevenueChart,
  sspsCpmChart,
  sspsHistoryChart,
  sspsColors,
  sspsProviders
} from '../data'
import * as axios from "axios";
import { authComputed } from '@state/helpers'

const DASHBOARD_API_URL = process.env.VUE_APP_API_URL + 'dashboard/';
const SITES_API_URL = process.env.VUE_APP_API_URL + 'sites/';
const COMMANDS_API_URL = process.env.VUE_APP_API_URL + 'commands/';
const PROVIDER_REPORTS_API_URL = process.env.VUE_APP_API_URL + 'provider-connectors/';
const CALCULATE_REVENUE_API_URL = process.env.VUE_APP_API_URL + 'provider-connectors/calculate-revenues';
const PREBID_PROVIDERS_API_URL = process.env.VUE_APP_API_URL + 'prebid-providers/';
export default {
  page: {
    title: 'SSPS',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { vueDropzone: vue2Dropzone, countTo, DatePicker, Layout, Multiselect },
  data() {
    return {
      allProviders: sspsProviders,
      allRunReportProviders: [],
      selectedProvider: [],
      allProvidersData: [],
      selectedProvidersData: [],
      sitesGrouped: true,
      loading: true,
      showOneProvider: false,
      selectedDate: '',
      runReportProvider: undefined,
      runReportDate: '',
      runReportErrorMessage: '',
      sspsChartApiData: [],
      sspsHistoryChart: {},
      sspsImpressionChart: {
        chartOptions: {},
        series: []
      },
      sspsRevenueChart: {
        chartOptions: {},
        series: []
      },
      sspsCpmChart: {
        chartOptions: {},
        series: []
      },
      sspsColors: sspsColors,
      selectedSite: '',
      preSelectedSite: '',
      allSites: [],
      sitesData: [],
      sitesDataByDate: [],
      title: 'SSPS',
      items: [
            {
                text: 'Unblockia',
                href: '/',
            },
            {
                text: 'Providers',
                href: '/',
            },
        ],
      shortcuts: [
        {
          text: 'Yesterday',
          onClick: () => {
            this.selectedDate = [new Date(this.yesterday), new Date(this.yesterday)];
            return 'Yesterday';
          },
        },
        {
          text: 'Last 7 days',
          onClick: () => {
            this.selectedDate = [new Date(this.sevenDaysAgo), new Date(this.yesterday)];
            return this.yesterday;
          },
        },
        {
          text: 'Last 30 days',
          onClick: () => {
            this.selectedDate = [new Date(this.thirtyDaysAgo), new Date(this.yesterday)];
            return this.thirtyDaysAgo;
          },
        },
      ],
      siteDataFields: [
        { key: 'no.', stickyColumn: true},
        { key: 'domain', sortable: true},
        { key: 'impressions', sortable: true},
        { key: 'requests', sortable: true},
        { key: 'cpm', label:"CPM", sortable: true},
        { key: 'revenue', sortable: true},
      ],
      siteDataByDateFields: [
        { key: 'no.', stickyColumn: true},
        { key: 'date', sortable: true},
        { key: 'domain', sortable: true},
        { key: 'impressions', sortable: true},
        { key: 'requests', sortable: true},
        { key: 'cpm', label:"CPM", sortable: true},
        { key: 'revenue', sortable: true},
      ],
      COMMANDS_API_URL,
      rows:'',
      perPage: 25,
      currentPage: 1,
      sortBy: 'domain',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      runningReport: false,
      calculatingRevenue: false,
      reportError: false,
      providerOnReport: '',
      reportIsDone: false

    }
  },
  computed: {

    yesterday: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 1)
    },
    sevenDaysAgo: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 8)
    },
    thirtyDaysAgo: function() {
      const d = new Date();
      return d.setDate(d.getDate() - 31)
    },
    ...authComputed,

    fromTo: function () {
      return `from=${this.prettyDate(this.selectedDate[0])}&to=${this.prettyDate(this.selectedDate[1])}`
    },

  },
  async mounted() {
    if (this.$route.query.siteId) {
      this.preSelectedSite = this.$route.query.siteId;
    }
    this.selectedDate = [new Date(this.sevenDaysAgo), new Date(this.yesterday)];
    this.runReportDate = new Date(this.yesterday);
    await this.init();
    this.loading = false;
  },
  methods: {
    dropzoneOptions: function(provider) {
      return {
        url: PREBID_PROVIDERS_API_URL + provider  + '-report',
        thumbnailWidth: 300,
        maxFilesize: 5,
        headers: { 'My-Awesome-Header': 'header value' },
      }
      },
    handleCsvUpload: function(provider) {
        Vue.swal({
          title: 'Good job!',
          text: provider + ' Data imported successfully!',
          type: 'success',
          confirmButtonClass: 'btn btn-confirm mt-2',
        });
      this.runReportProvider = undefined;
    },
    prettyDate: function (date) {
      // `this` points to the vm instance
      const d = new Date(date);
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return yyyy + '-' + mm + '-' + dd;
    },
    handleSitesGrouped() {
      if(this.sitesGrouped){
        this.rows = this.sitesData.length
      }else{
        this.rows = this.sitesDataByDate.length
      }
    },
    selectProviderData() {
      if(this.selectedProvider.length === 1) {
        this.selectedProvidersData = this.allProvidersData.filter( provider => provider.name == this.selectedProvider[0])
      } else if (this.selectedProvider.length === 0) {
        this.selectedProvidersData = this.allProvidersData.filter( provider => this.allProviders.includes(provider.name))
      } else {
        this.selectedProvidersData = this.allProvidersData.filter( provider => this.selectedProvider.includes(provider.name))
      }
    },
    async fetchProviderList() {
      const response = await axios(PREBID_PROVIDERS_API_URL);
      this.allRunReportProviders = response.data.results;
    },
    async fetchSiteList() {
      const response = await axios(SITES_API_URL + `all/grouped-by-publisher`);
      this.allSites = response.data;
    },

    async fetchSspsTotal() {
      if(!this.selectedSite){
        this.selectedSite = ''
      }
      const response = await axios(DASHBOARD_API_URL + `stats/ssps/total?${this.fromTo}&siteId=${this.selectedSite.id}`);
      this.allProvidersData = response.data.providersTotalData;
      this.selectProviderData();
    },

    async fetchSspsHistory() {
      if(!this.selectedSite){
        this.selectedSite = ''
      }
      const response = await axios(DASHBOARD_API_URL + `stats/ssps/history?${this.fromTo}&siteId=${this.selectedSite.id}`);
      if (this.selectedProvider.length === 0) {
        this.sspsChartApiData = response.data;
      } else {
        this.sspsChartApiData = response.data.map( daily => {
          daily.providerStats = daily.providerStats.filter( stat => {
            return this.selectedProvider.includes(stat.name)
           });
           return daily
        });
      }
    },

    async fetchSspsSites() {
      if(!this.selectedSite){
        this.selectedSite = ''
      }
      const response = await axios(DASHBOARD_API_URL + `stats/ssps/sites?${this.fromTo}&provider=${this.selectedProvider[0]}&siteId=${this.selectedSite.id}`);
      this.sitesData = response.data.sitesData;
      this.sitesDataByDate = response.data.sitesDataByDate;
      this.rows = this.sitesData.length;
    },

    convertSspsHistoryChart() {
      if (this.sspsChartApiData && this.sspsChartApiData.length && this.selectedProvider.length === 1) {
        this.sspsHistoryChart = sspsHistoryChart(this.selectedProvider[0], this.sspsChartApiData);
      } else {
        this.sspsHistoryChart = {
          chartOptions: {},
          series: []
        }
      }
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length;
        this.currentPage = 1
    },
    async init() {
      this.loading = true;
    await this.fetchProviderList();
      await this.fetchSiteList();

      if (this.preSelectedSite) {
        this.selectedSite = this.allSites.map(x => x.sites).flat().find(x => parseInt(x.id) === parseInt(this.preSelectedSite));
        this.preSelectedSite = '';
      }
      await this.fetchSspsTotal();
      await this.fetchSspsHistory();

      if (this.selectedProvider.length === 1) {
        /* When select one provider, fetch site data, show history chat and site list */
        this.showOneProvider = true;
        await this.fetchSspsSites();
        this.convertSspsHistoryChart();
      } else {
        /* In other cases, show revenue chart, cpm chart and impression chart */
        this.showOneProvider = false;

        /* get sspsImpressionChart*/
        if (this.sspsChartApiData && this.sspsChartApiData.length) {
          if (this.selectedProvider.length === 0) {
            this.sspsImpressionChart = sspsImpressionChart(this.sspsChartApiData, this.allProviders, this.findMax('impressions'));
          } else {
            this.sspsImpressionChart = sspsImpressionChart(this.sspsChartApiData, this.selectedProvider, this.findMax('impressions'));
          }
        } else {
          this.sspsImpressionChart = {
            chartOptions: {},
            series: []
          }
        }
        /* get sspsRevenueChart*/
        if (this.sspsChartApiData && this.sspsChartApiData.length) {
          if (this.selectedProvider.length === 0) {
            this.sspsRevenueChart = sspsRevenueChart(this.sspsChartApiData, this.allProviders, this.findMax('revenue'));
          } else {
            this.sspsRevenueChart = sspsRevenueChart(this.sspsChartApiData, this.selectedProvider, this.findMax('revenue'));
          }
        } else {
          this.sspsRevenueChart = {
            chartOptions: {},
            series: []
          }
        }
        /* get sspsCpmChart*/
        if (this.sspsChartApiData && this.sspsChartApiData.length) {
          if (this.selectedProvider.length === 0) {
            this.sspsCpmChart = sspsCpmChart(this.sspsChartApiData, this.allProviders, this.findMax('cpm'));
          } else {
            this.sspsCpmChart = sspsCpmChart(this.sspsChartApiData, this.selectedProvider, this.findMax('cpm'));
          }

        } else {
          this.sspsCpmChart = {
            chartOptions: {},
            series: []
          }
        }
      }

      this.loading = false;
    },
    providerLabel(provider){
      return `${provider.name} (${provider.company}) `;
    },
    findMax(metric) {
       let maxNum = 0;
        this.sspsChartApiData.forEach( date => {
          date.providerStats.forEach( data => {
            if( data[metric] > maxNum ) {
              maxNum = data[metric];
            }
          } )
        });
        if(maxNum < 1) {
          return maxNum
        }
        const length = maxNum.toFixed(0).toString().length;
        maxNum = Math.ceil(maxNum / Math.pow(10, length - 1)) * Math.pow(10, length - 1);
        return maxNum
    },

    async runProviderReport() {
      this.reportError = false;
      this.reportIsDone = false;
      this.runReportErrorMessage = '';
      if(!this.runReportProvider) {
        this.runReportErrorMessage = 'Provider is required';
        return
      }
      try {
        let reportResponse;
        this.runningReport = true;
        if(this.runReportProvider.reportingApi){
          const axiosData = {
            method: 'post',
            url: PROVIDER_REPORTS_API_URL,
            data: {
              providerId: this.runReportProvider.id,
              date: this.prettyDate(this.runReportDate),
            }
          };

          reportResponse = await axios(axiosData);
        } else {
          reportResponse = await axios(COMMANDS_API_URL + `singleStats/${this.runReportProvider.alias.replace(' ', '_').toLowerCase()}?date=${this.prettyDate(this.runReportDate) }`);
        }

        this.runningReport = false;
        if(reportResponse.data){
          this.reportIsDone = true;
        } else {
          this.reportError = true;
        }
      } catch (e) {
        console.log(e);
      }

      setTimeout(() => {
          this.reportError = false;
          this.reportIsDone = false;
      }, 2000)

    },
    async calculateRevenue() {
      try {
        let revenueResponse;
        this.calculatingRevenue = true;
          const axiosData = {
            method: 'post',
            url: CALCULATE_REVENUE_API_URL,
            params: {
              date: this.prettyDate(this.runReportDate),
            }
          };

        revenueResponse = await axios(axiosData);
        this.calculatingRevenue = false;
      } catch (e) {
        console.log(e);
      }
    },

    labelWithPublisher({ domain, publisher }){
        return `${domain} — [${publisher}]`
    }

  }
}
</script>

<template>
  <Layout>
    <div class="row home-page">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Providers</h4>
          <div class="mt-2 d-flex flex-column align-items-end">
            <form class="form-inline mb-2">
              <div class="form-group d-flex flex-wrap col-12">
                <div class="input-group input-group-sm mr-2 ">
                  <multiselect
                             v-model="selectedSite"
                             :options="allSites"
                             :searchable="true"
                             track-by="id"
                             label="domain"
                             group-values="sites"
                             group-label="publisher"
                             :group-select="true"
                             placeholder="Select a site"
                             :custom-label="labelWithPublisher"
                  ></multiselect>
                </div>
                <div class="input-group input-group-sm mr-2">
                  <multiselect
                             v-model="selectedProvider"
                             :options="allProviders"
                             :searchable="true"
                             placeholder="Select provider"
                             multiple
                  ></multiselect>
                </div>
                <div class="input-group input-group-sm">
                  <date-picker
                         v-model="selectedDate"
                         :first-day-of-week="1"
                         class="border-white home-date-picker"
                         :not-after="yesterday"
                         range
                         append-to-body
                         lang="en"
                         :shortcuts="shortcuts"
                         confirm
                  >
                  </date-picker>
                </div>
                <a href="javascript: void(0);" class="btn btn-blue btn-sm ml-2 mr-1" @click="init">
                  <i class="mdi mdi-autorenew"></i>
                </a>  

                <b-button v-b-toggle.collapse-1 size="sm" variant="primary"><i class="fe-settings" slot="button-content"></i></b-button>

              </div>

            </form>

            <div class="col-12 pl-0 pr-0 mt-2">
              <b-collapse id="collapse-1" class="border run-report-wrapper bg-white">
                <div class="d-flex flex-column align-items-center pt-2 pb-2">
                  <form class="form-inline">
                    <div class="form-group d-flex flex-wrap  col-12">
                      <div class="input-group input-group-sm mr-2">
                        <multiselect
                                  v-model="runReportProvider"
                                  :options="allRunReportProviders"
                                  track-by="alias"
                                  :custom-label="providerLabel"
                                  label="name"
                                  :searchable="true"
                                  placeholder="Select a provider"
                                  required
                        ></multiselect>
                      </div>
                      <div class="input-group input-group-sm">
                        <date-picker
                              v-model="runReportDate"
                              :first-day-of-week="1"
                              class="border-white home-date-picker"
                              :not-after="yesterday"
                              append-to-body
                              type="date"
                              lang="en"
                              :disabled="runReportProvider && runReportProvider.name === 'vuukle'"
                        >
                        </date-picker>
                      </div>

                      <b-button :disabled="runReportProvider && runReportProvider.name === 'vuukle'" v-if="!this.runningReport" class="ml-2" size="sm" variant="warning" @click="runProviderReport()">Run Report </b-button>
                      <b-button v-if="this.runningReport" variant="warning" size="sm"  disabled class="ml-2">
                        <b-spinner small></b-spinner>&nbsp;&nbsp;Running report
                      </b-button>

                      <b-button v-if="!this.calculatingRevenue" class="btn btn-warning btn-sm ml-2 mr-1" @click="calculateRevenue()">
                        Recalculate Revenues 
                      </b-button>
                      <b-button v-if="this.calculatingRevenue" class="btn btn-warning btn-sm ml-2 mr-1"  disabled>
                        <b-spinner small></b-spinner>Recalculating Revenues
                      </b-button>

                    </div>

                  </form>
                  <div class="col-12" v-if="runReportProvider && runReportProvider.name === 'vuukle'">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="header-title m-t-0">Vuukle File Upload</h4>
                        <p
                                class="text-muted font-13 m-b-30"
                        >Drop here the csv of Vuukle</p>
                        <!-- file upload -->
                        <vue-dropzone id="dropzoneVuukle" ref="myVueDropzoneVuukle" :options="dropzoneOptions('vuukle')" v-on:vdropzone-complete="handleCsvUpload('Vuukle')"></vue-dropzone>
                      </div>
                    </div>
                  </div>

                  <div class="col-12" v-if="runReportProvider && runReportProvider.name === 'unibots'">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="header-title m-t-0">Unibots File Upload</h4>
                        <p
                                class="text-muted font-13 m-b-30"
                        >Drop here the csv of Unibots</p>
                        <!-- file upload -->
                        <vue-dropzone id="dropzoneUnibots" ref="myVueDropzoneUnibots" :options="dropzoneOptions('unibots')" v-on:vdropzone-complete="handleCsvUpload('Unibots')"></vue-dropzone>
                      </div>
                    </div>
                  </div>
                  <p class="mb-0 mt-1 text-danger">{{runReportErrorMessage}}</p>
                </div>

              </b-collapse>
            </div>

          </div>

        </div>
      </div>
    </div>

    <div v-if="loading" class="row justify-content-center" >
      <b-spinner label="Spinning" class="m-2"></b-spinner>
    </div>
    <div v-else>
      <div class="row mb-3 mt-3">
        <div
                 v-for="provider in selectedProvidersData"
                 :key="provider.id"
                 :class="[showOneProvider ? 'col-md-4 col-xl-4' : 'col-md-6 col-xl-4']"
        >
          <div class="widget-rounded-circle card-box ribbon-box widget-unit border">
            <div class="row">
              <div class="col-5">
                <h4
                  class="provider-name"
                  :class="` pb-1 text-secondary`"
                > <strong>{{provider.name}}</strong> </h4>
                <svg version="1.1" class="ssps-logo ml-3" width='40' x="0px" y="0px" viewBox="0 0 8.5 10.6"
                  style="enable-background:new 0 0 8.5 10.6;" xml:space="preserve">
                <g>
                  <path :fill="sspsColors[`${provider.name.replace(' ', '_').toUpperCase()}_COLOR`]"  d="M4.3,0.5C4.3,0.5,4.3,0.5,4.3,0.5L2.5,3.3l-1.8,1C0.6,4.4,0.6,4.5,0.6,4.6L0.1,4.9c0,0,0,0,0,0C0,5,0,5.1,0,5.3l1,1.7
                    C1.1,7.1,1.2,7.1,1.4,7c0,0,0,0,0,0l0.5-0.3c0.1,0.1,0.2,0.1,0.3,0l0.2-0.1L3.6,8c0.1,0.1,0.2,0.1,0.3,0l0.9-0.5
                    c0.1-0.1,0.2-0.2,0.1-0.4c0,0,0,0,0-0.1L3.6,5.9l0.3-0.2l3.3-0.1c0.1,0,0.3-0.1,0.3-0.3c0,0,0-0.1,0-0.1L4.7,0.6
                    C4.6,0.4,4.5,0.4,4.3,0.5C4.3,0.5,4.3,0.5,4.3,0.5z M4.5,1.2l2.3,3.9L4,5.2L3,3.5L4.5,1.2z M6.3,0.4c-0.1,0-0.1,0.1-0.1,0.2L6,1.3
                    c0,0.1,0,0.3,0.2,0.3c0.1,0,0.3,0,0.3-0.2c0,0,0,0,0,0l0.2-0.7c0-0.1,0-0.3-0.2-0.3C6.5,0.4,6.4,0.4,6.3,0.4z M1.2,4.6l1.4-0.8
                    l0.9,1.6L3.1,5.7L2.2,6.1L2.1,6.2L1.2,4.6z M0.6,5.2l0.3-0.1l0.7,1.2L1.3,6.5L0.6,5.2z M7.2,2C7.2,2,7.2,2,7.2,2C7,2,7,2.2,7.1,2.3
                    c0.1,0.1,0.2,0.2,0.4,0.1L8.1,2C8.2,2,8.3,1.8,8.2,1.7C8.1,1.5,8,1.5,7.8,1.6c0,0,0,0,0,0L7.2,2C7.2,1.9,7.2,1.9,7.2,2z M7.4,3.3
                    C7.3,3.3,7.3,3.3,7.4,3.3C7.2,3.4,7.2,3.5,7.3,3.6c0,0.1,0.1,0.1,0.1,0.1l0.7,0.2c0.1,0,0.3,0,0.3-0.2c0-0.1,0-0.3-0.2-0.3
                    c0,0,0,0,0,0L7.6,3.2C7.5,3.2,7.4,3.2,7.4,3.3z M2.8,6.4l0.4-0.2l1,1L3.8,7.5L2.8,6.4z"/>
                </g>
                </svg>
                <!-- <img :src="provider.image"></img> -->
              </div>
              <div class="col-7">
                <div class="text-left">

                  <p v-if="provider.impressions" class="text-muted mb-1 text-truncate">Impressions: <countTo :decimals="0" separator="." :end-val="provider.impressions" :duration="1"></countTo></p>
                  <p v-else class="text-muted mb-1 text-truncate">Impressions: 0 </p>
                  <p v-if="provider.requests" class="text-muted mb-1 text-truncate">Requests: <countTo :decimals="0" separator="." :end-val="provider.requests" :duration="1"></countTo></p>
                  <p v-else class="text-muted mb-1 text-truncate">Requests: 0 </p>
                  <p class="text-muted mb-1 text-truncate">eCPM: <countTo :decimals="2" decimal="," separator="." :end-val="provider.cpm" :duration="1"></countTo>€</p>
                  <p v-if="provider.name==='Publisher Demand'" class="text-muted mb-1 text-truncate">Gross revenue: <countTo :decimals="2" decimal="," separator="." :end-val="provider.revenue" :duration="1"></countTo>€</p>
                  <p v-else class="text-muted mb-1 text-truncate">Revenue: <countTo :decimals="2" decimal="," separator="." :end-val="provider.revenue" :duration="1"></countTo>€</p>
                  <p v-if="provider.name==='Publisher Demand'"class="text-muted mb-1 text-truncate">Unblockia's share: <countTo :decimals="2" decimal="," separator="." :end-val="provider.revenue*0.2" :duration="1"></countTo>€</p>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <div class="row" v-if="!showOneProvider">
        <div class="col-xl-12">
          <div class="card-box pb-1">
            <h4 class="header-title mb-3"> Revenue </h4>
            <div style="height: 375px;">
              <apexchart
                      height="370"
                      type="line"
                      :options="sspsRevenueChart.chartOptions"
                      :series="sspsRevenueChart.series"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!showOneProvider">
        <div class="col-xl-12">
          <div class="card-box pb-1">
            <h4 class="header-title mb-3">Impression</h4>
            <div style="height: 375px;">
              <apexchart
                      height="370"
                      type="line"
                      :options="sspsImpressionChart.chartOptions"
                      :series="sspsImpressionChart.series"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!showOneProvider">
        <div class="col-xl-12">
          <div class="card-box pb-1">
            <h4 class="header-title mb-3">CPM</h4>
            <div style="height: 375px;">
              <apexchart
                      height="370"
                      type="line"
                      :options="sspsCpmChart.chartOptions"
                      :series="sspsCpmChart.series"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="showOneProvider">
        <div class="col-xl-12">
          <div class="card-box pb-1">
            <h4 class="header-title mb-3">Overview</h4>
            <div style="height: 375px;">
              <apexchart
                      height="370"
                      type="line"
                      :options="sspsHistoryChart.chartOptions"
                      :series="sspsHistoryChart.series"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="showOneProvider">
        <div class="col-xl-12">
          <div class="card-box">

            <div class="d-flex justify-content-between mb-3">
              <h4 class="header-title">Sites</h4>
              <div class="d-flex">

                <div class="col-md-7 col-sm-6">
                    <div id="tickets-table_filter" class="dataTables_filter">
                        <label class="d-inline-flex align-items-center">
                            Search:
                            <b-form-input
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search..."
                                    class="form-control form-control-sm ml-2 "
                            ></b-form-input>
                        </label>
                    </div>
                </div>
                <div class="custom-control custom-checkbox ml-2 pt-1">
                  <input
                      id="customCheck1"
                      v-model="sitesGrouped"
                      type="checkbox"
                      class="custom-control-input"
                      @change="handleSitesGrouped"
                  />
                  <label
                          class="custom-control-label"
                          for="customCheck1"

                  >Group by domain</label>
                </div>

              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                  sort-icon-left
                 :items="sitesGrouped ? sitesData : sitesDataByDate "
                 :fields="sitesGrouped ? siteDataFields : siteDataByDateFields"
                 responsive="sm"
                 :per-page="perPage"
                 :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                 :filter="filter"
                 @filtered="onFiltered"
                 :filter-included-fields="filterOn"
              >
             <template #cell(no.)="data">
                 <b class="field">{{ (currentPage-1) * perPage + data.index + 1 }}</b>
              </template>
              <template #cell(impressions)="data">
                <b class="field">{{ data.item.impressions ? data.item.impressions.toLocaleString('de-DE') : 0}}</b>
              </template>
              <template #cell(requests)="data">
                <b class="field">{{ data.item.requests ? data.item.requests.toLocaleString('de-DE') : 0}}</b>
              </template>
              <template #cell(cpm)="data">
                 <b class="field" v-if="data.item.cpm">{{ data.item.cpm.toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' }}</b>
                 <b class="field" v-else> - </b>
              </template>
              <template #cell(revenue)="data">
                 <b class="field">{{ data.item.revenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' }}</b>
              </template>

              </b-table>
            </div>
            <div class="row">
                <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">

                            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </Layout>
</template>


<style lang="scss" >

  .mode-selector {
    text-align: right;
  }

  .revenue-ribbon {
    position: absolute!important;
    top: 5px!important;
  }

  .home-page {
    .site-select {
      height: 35px !important;
    }
    .home-date-picker {
      width: 240px!important;
    }
    .mx-shortcuts {
      font-weight: bold!important;
      text-decoration: underline;
    }
    .download-btn {
      height: 32px;
      line-height: 18px;
    }

    .multiselect__content-wrapper {
      width: 100%!important;

    }
    .multiselect__tags {
      max-width: 400px!important;
      min-width: 300px!important;
      height: 37px;
      overflow: scroll !important;
      margin-top: 1.5px;
    }
    ::-webkit-scrollbar
    {
        width:0px;
        height:0px;
    }
    .flex-form{
    display: flex;
    flex-direction: row;
    align-items: flex-start !important;
    }

  }

  .field{
    font-weight: 300;
  }

  .widget-unit{
    height: 175px;

    img{
      width: 20px;
    }
  }

  .run-report-wrapper{
    border-radius: 8px;
  }

  .provider-name{
    /* display: inline-block;
    width: 110px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis; */

  }

  .ssps-setting{
    position: absolute;
    right: 1rem;
    top: 1rem;
    button{
      padding: 0 !important;
    }
    ul{
      min-width: 0;
    }
  }

  .run-report-status{
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 2;
  }





</style>
